import { React, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Moment from 'react-moment';
import moment from 'moment';
import 'moment/locale/it'; // Importa la localizzazione italiana

import { useSearchParams, useParams } from 'react-router-dom';

import axios from 'axios';

import { useLoader } from '../../utils/hooks';
import Slider_cms from '../layouts/home/slider';

import NewsSlider from './news_slider';

const News_Details = (props) => {
  const [news, SetNews] = useState('');

  const { t, i18n } = useTranslation();
  useEffect(() => {
    // Imposta la lingua per moment.js
    moment.locale(i18n.language === 'it' ? 'it' : 'en');
  }, [i18n.language]);

  const loader = useLoader({ height: '90vh' });

  const params = useParams();
  const slug = params.slug;

  useEffect(() => {
    document.getElementById('home_page_class').classList.remove('home_page');
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    loader.watchPromise(
      axios.get('/v1/blog-detail?slug=' + slug).then((response) => {
        SetNews(response.data.result.data);
      })
    );
  }, [slug]);

  const [prevNewsurl, setPrevNewsurl] = useState(null);
  const [nextNewsurl, setNextNewsurl] = useState(null);
  const [prevarticle, setPrevarticle] = useState(null);
  const [nextarticle, setNextarticle] = useState(null);

  useEffect(() => {
    if (news && news.id) {
      axios.get(`/v1/blog-prev-next?currentId=${news.id}`).then((response) => {
        setPrevNewsurl(response.data.result.prev);
        setNextNewsurl(response.data.result.next);
        //console.log(response.data.result.data_prev.meta_tag_title);
        setPrevarticle(response.data.result.data_prev);
        setNextarticle(response.data.result.data_next);
      });
    }
  }, [news]);
  
  const dateFormat = i18n.language === 'en' ? "MMM Do YYYY" : "D MMM YYYY"; //formato data eng o ita
  
  //console.log(prevarticle.meta_tag_title);
  //console.log(nextarticle);
  return (
    <div className="main_content blog_detail pitti">

    {news.blog_base_image_url ? (
      <div className="image news-open-image">
        {news.background_image_url ? (
          <img src={news.background_image_url} alt="" />
        ) : (
          news.blog_base_image_url && <img src={news.blog_base_image_url} alt="" />
        )}
      </div>
    ) : null}

      <div className="blog-content news-content">
        {loader.asJsx || (
          <>
            <div className="breadcrumb">
            <span style={{ color: '#c2c2c2' }}><a href="/">Home</a> | <a href={`/${i18n.language}/news`}>News</a> | {news?.category?.name} |</span> <span style={{ color: '#333E48' }}>{news?.title}</span>
            </div>
            
            <div className="title_section">
              <p>
                {((news?.category_id!==13 ) && news?.category?.id!=='13') && (
                  moment(news.blog_date).locale(i18n.language).format(dateFormat).replace(/\b\p{L}/u, c => c.toUpperCase())
                )}
              </p>
              <h2>{news?.title}</h2>
              <h4>{news?.subtitle}</h4>
            </div>

            <div dangerouslySetInnerHTML={{ __html: news.description }}></div>

            {news?.blog_image_url && news.blog_image_url.length > 0 ? (
              <div className="seller_section container news-grid-images">
                <Slider_cms images={news.blog_image_url || []} />
              </div>
            ) : null}

            <div className="prev-next-div">
              <div className="flex-pn-div">
                <div className="single-pn-flex div-prev">
                  <a href={prevNewsurl}>{prevarticle?.meta_tag_title}</a>
                </div>
                <div className="single-pn-flex div-pn-center">
                  <a
                    id="prev-news-text"
                    className={!prevNewsurl ? 'no-prev' : ''}
                  >
                    {t('Precedente_news')}
                  </a>

                  <a
                    id="prev-news-link"
                    href={prevNewsurl}
                    className={`news-prev-button ${!prevNewsurl ? 'no-prev' : ''}`}
                  ></a>

                  <a
                    id="next-news-link"
                    href={nextNewsurl}
                    className={`news-next-button ${!nextNewsurl ? 'no-next' : ''}`}
                  ></a>

                  <a
                    id="next-news-text"
                    className={!nextNewsurl ? 'no-next' : ''}
                  >
                    {t('Successivo_news')}
                  </a>
                </div>
                <div className="single-pn-flex div-next">
                  <a href={nextNewsurl}>{nextarticle?.meta_tag_title}</a>
                </div>
              </div>
            </div>
          </>
        )}
        <NewsSlider title={t('scopri_altre_news')} />
      </div>
    </div>
  );
};

export default News_Details;